/**
 * 用户信息面板
 * Bai.Zhiming
 * 2019-7-17
 */
angular.module("c2cInfoPanelModule", []).
directive("c2cInfoPanel", ["imService", 'modalDialog', function(imService, modalDialog) {
    return {
        restrict: "E",
        scope: false,
        replace: true,
        templateUrl: "./IM/chatWindow/infoPanel/c2cInfoPanel/c2cInfoPanel_tpl.html",
        link(scope, $element, $attrs) {
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                let status = {
                    logonTimers: 0
                }
                let data = {};
                angular.extend(scope.status, status)
                angular.extend(scope.data, data)
            }
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                initWatchSelectedUser();
            }
            /**
             * [initWatchSelectedUser description] 初始化监控选中用户
             * @return {[type]} [description]
             */
            function initWatchSelectedUser() {
                scope.$watch('c2cInfo', (newV, oldV) => {
                    console.log(newV, oldV);
                });
            }
            /**
             * [sendMessage description] 发起聊天
             * @return {[type]} [description]
             */
            scope.sendMessage = function() {
                if (scope.status.logonTimers >= 3) {
                    scope.status.logonTimers = 0;
                    modalDialog.alertType('该用户注册聊天账号失败', '', 'error', false);
                    return;
                }
                let account = `${scope.status.c2cInfo.TENANTID}_${scope.status.c2cInfo.UNAME}`;
                let myAccount = `${scope.loginInfo.TENANTID}_${scope.loginInfo.USERNAME}`;
                let tag_list = [
                    "Tag_Profile_IM_Nick", //昵称
                    "Tag_Profile_IM_Gender", //性别
                    "Tag_Profile_IM_AllowType", //加好友方式
                    "Tag_Profile_IM_Image" //头像
                ];
                let options = {
                    'To_Account': [account],
                    'TagList': tag_list
                };
                webim.getProfilePortrait(options, resp => {
                    imService.applyAddFriend(account, myAccount).then(() => {
                        let userInfo = resp.UserProfileItem[0];
                        let ProfileItem = userInfo.ProfileItem;

                        if (!angular.isArray(ProfileItem) || !angular.isObject(ProfileItem[0]) || !ProfileItem[0].Value) { //没有用户昵称，修复数据 
                            scope.status.logonTimers++;
                            imService.logonIm(account, scope.status.c2cInfo.USERNAME, scope.status.c2cInfo.headUrl).then(() => {
                                scope.sendMessage();
                            });
                            return;
                        }
                        if (angular.isFunction(scope.fn.selectedUser)) {
                            scope.fn.selectedUser(userInfo);
                        }
                    });
                }, error => {
                    if (!angular.isObject(error) || !error.ErrorCode) {
                        modalDialog.alertType("获取用户资料失败", "", "error", false);
                        return;
                    }
                    if (error.ErrorCode == 40003 || error.ErrorCode == 99999) { //如果用户不存在，当场给他注册个账号
                        scope.status.logonTimers++;
                        scope.loaders = imService.logonIm(account, scope.status.c2cInfo.USERNAME, scope.status.c2cInfo.headUrl).then(() => {
                            scope.sendMessage();
                        });
                    }
                });
            };
        }
    };
}]);